import { useEffect, useState } from 'react';

/**
 * useContainerWidth — Sep 2026. Measures a container's width (ResizeObserver)
 * so hand-drawn SVG charts can size their viewBox to the real card width.
 * Previously the modal's price / RSI / yield charts were drawn at a fixed
 * 700px with `min-w-[400px]`, which forced side-to-side scrolling on phones.
 */
export default function useContainerWidth(ref, fallback = 700, min = 300) {
  const [width, setWidth] = useState(fallback);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const apply = () => {
      const w = Math.round(el.getBoundingClientRect().width);
      if (w > 0) setWidth(Math.max(min, w));
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref, min]);
  return width;
}
